import { createContext } from 'react';
export const ToastContext = createContext({
    info: (_payload) => { },
    error: (_payload) => { },
    success: (_payload) => { },
});
//# sourceMappingURL=toast-context.js.map